import gql from 'graphql-tag';

export const ALLANO = gql`
query getAnos{
  anos{
    id
    ano
    primerDia
  }
}
`;


export const ANO = gql`
query getAno($ano:Int){
  ano(ano:$ano){
    primerDia
    ano
  }
}
`;
